import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";
import "LIBS/jquery.showhtml.js";


HSN.AddedToBagOffCanvas = (function (parent) {
    __extends(AddedToBagOffCanvas, parent);

    function AddedToBagOffCanvas() {
        this.deviceInformation = HSN.Instance().DeviceInformation;
        var offCanvas = AddedToBagOffCanvas.__super__.constructor.call(this, {
            className: 'added-to-bag-off-canvas',
            sourceDirection: this.deviceInformation.IsMobile ? HSN.OffCanvas.SOURCE_DIRECTION.BOTTOM : HSN.OffCanvas.SOURCE_DIRECTION.RIGHT,
            maskPage: true
        });
        this._scope = this;
        this.name = 'HSN.AddedToBagOffCanvas';
        this.commerceService = HSN.Instance()._getCommerceService();
        this.Close.off(); //remove existing handler, have our own
        
        eventHandlers(this);

        HSN.DataLayer.helpers.virtualPageview(null, 'OffCanvas: Added To Bag', 'AddedToBagOffCanvas', 'Added To Bag Off Canvas');

        return offCanvas;
    }

    function eventHandlers(offCanvas) {
        $(offCanvas.Content).on('click', '.warranty-option-input', function () {
            $('.warranty-option-input', offCanvas.Content).not(this).prop('checked', false);
        });
        $(offCanvas.Content).on('change', '.warranty-option-input', function () {
            var checkbox = $(this);
            var isChecked = checkbox.is(':checked');
            var bagIdentity = offCanvas.Content.find('.added-to-bag-container').data('bag-id');
            var bagItemIdentity = offCanvas.Content.find('.added-to-bag-container').data('bag-item-id');
            var warrantyItemId = checkbox.val();
            HSN.SetWait();
            if (isChecked) {
                HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Add', 'AddToBagButton');
                offCanvas.commerceService.AddWarrantyToBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemIdentity, warrantyItemId: warrantyItemId}, {
                    callback: function (data) {
                        HSN.RemoveWait();
                        if (!data.success) {
                            checkbox.prop('checked', !isChecked);
                            alert('There was a problem adding your warranty. Please try again later.');
                        }
                    },
                    scope: offCanvas
                });
            }
            else {
                HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Remove', 'AddToBagButton');
                offCanvas.commerceService.RemoveWarrantyFromBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemIdentity}, {
                    callback: function (data) {
                        HSN.RemoveWait();
                        if (!data.success) {
                            checkbox.prop('checked', !isChecked);
                            alert('There was a problem removing your warranty. Please try again later.');
                        }
                    },
                    scope: offCanvas
                });
            }
            
        });
        $(offCanvas.Content).on('click', '#continue-shopping', function() {
            HSN.DataLayer.helpers.metricEvent(null, 'AddToBagModal', 'ContinueShopping', 'ContinueShoppingButton');
            offCanvas.Hide();
        });

        $(offCanvas.Content).on('click', '#view-bag', function() {
            handleNavigation(offCanvas);
        });

        $(offCanvas.Content).on('keydown', '#view-bag', function (e) {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                e.stopPropagation();
                handleNavigation(offCanvas);
            }
        });
        $(offCanvas.Close).on('click', function (e) {
            HSN.DataLayer.helpers.metricEvent(null, 'AddToBagModal', 'Close', 'CloseButton');
            offCanvas.Hide();
        });
    }

    function handleNavigation(offCanvas) {
        HSN.DataLayer.helpers.metricEvent(null, 'AddToBagModal', 'ViewBag', 'ViewBagButton');
        var path = isExpressBuy(offCanvas) ? '/checkout/order-review' : '/checkout/bag';
        window.location = window.location.protocol + '//' + window.location.hostname + path;
    }

    function isExpressBuy(offCanvas) {
        return $('.button-container.express', offCanvas.Content).length > 0 ? true : false;
    }

    AddedToBagOffCanvas.prototype._show = function (bagIdentity, bagItemIdentity) {
        $.ajax('/checkout/off-canvas/bag-item-added?bagIdentity=' + bagIdentity + '&bagItemIdentity=' + bagItemIdentity, {
            context: this,
            cache: false,
            dataType: 'html',
            data: {},
            success: function (data) {
                var scope = this;
                scope.DisplayContent(data);
                scope.SetFocus($('#view-bag'));
            },
            error: function () {
                var scope = this;
                scope.HandleError();
            }
        });
    };
    return AddedToBagOffCanvas;
})(HSN.OffCanvas);



// WEBPACK FOOTER //
// ./assets/js/HSN/OffCanvas/Checkout/AddedToBag.js